import { useSnackbar } from 'notistack';
import { SyntheticEvent, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useCollectiblesStore } from 'src/store/collectibles/collectibles.store';
import { useMyDataStore } from 'src/store/me/me.store';

export default function useCollectionsList() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { getCollectionsList, exportData } = useCollectiblesStore();

  const user = useMyDataStore((state) => state.me);

  const TABS = [
    { value: 'collections', label: 'Coleções' },
    { value: 'reports', label: 'Relatórios' },
  ];

  const [currentTab, setCurrentTab] = useState<'collections' | 'reports'>('collections');

  const [toExportIds, setToExportIds] = useState<string[]>([]);

  const handleChangeTab = useCallback(
    (event: SyntheticEvent, newValue: 'collections' | 'reports') => {
      setCurrentTab(newValue);
    },
    [setCurrentTab]
  );

  const onSelectAllRows = (ids: string[]) => {
    setToExportIds(ids);
  };

  const onSelectRow = (id: string) => {
    if (toExportIds.includes(id)) {
      setToExportIds(toExportIds.filter((item) => item !== id));
      return;
    }

    setToExportIds([...toExportIds, id]);
  };

  const onExport = () => {
    const ids = toExportIds.length ? toExportIds : [];
    if (ids.length === 0) {
      enqueueSnackbar('Por favor, selecione alguma coleção.', { variant: 'error' });
    } else {
      const userName = user?.name || 'Desconhecido';
      exportData(ids, userName);
      enqueueSnackbar('Seu relatório está sendo gerado!', { variant: 'info' });
      setCurrentTab('reports');
      setToExportIds([]);
    }
  };

  useEffect(() => {
    if (currentTab === 'collections') {
      getCollectionsList();
    }
  }, [currentTab, getCollectionsList]);

  return {
    TABS,
    currentTab,
    onSelectAllRows,
    onSelectRow,
    navigate,
    onExport,
    handleChangeTab,
  };
}
